var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 12.8255C3.39042 12.8255 3.00214 12.8255 2.69585 12.6987C2.28747 12.5295 1.96302 12.205 1.79386 11.7967C1.66699 11.4904 1.66699 11.1021 1.66699 10.3255V4.65885C1.66699 3.72543 1.66699 3.25872 1.84865 2.9022C2.00844 2.5886 2.2634 2.33363 2.57701 2.17384C2.93353 1.99219 3.40024 1.99219 4.33366 1.99219H10.0003C10.7769 1.99219 11.1652 1.99219 11.4715 2.11905C11.8798 2.28821 12.2043 2.61267 12.3735 3.02105C12.5003 3.32733 12.5003 3.71562 12.5003 4.49219M10.167 18.6589H15.667C16.6004 18.6589 17.0671 18.6589 17.4236 18.4772C17.7372 18.3174 17.9922 18.0624 18.152 17.7488C18.3337 17.3923 18.3337 16.9256 18.3337 15.9922V10.4922C18.3337 9.55877 18.3337 9.09206 18.152 8.73554C17.9922 8.42193 17.7372 8.16697 17.4236 8.00718C17.0671 7.82552 16.6004 7.82552 15.667 7.82552H10.167C9.23357 7.82552 8.76686 7.82552 8.41034 8.00718C8.09674 8.16697 7.84177 8.42193 7.68198 8.73554C7.50033 9.09206 7.50033 9.55877 7.50033 10.4922V15.9922C7.50033 16.9256 7.50033 17.3923 7.68198 17.7488C7.84177 18.0624 8.09674 18.3174 8.41034 18.4772C8.76686 18.6589 9.23357 18.6589 10.167 18.6589Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.85d1486f88c7fa51c062afebbbf80a0d.svg";
export { ForwardRef as ReactComponent };